var exports = {
  "w4": "x234b8571--9199dc--theme",
  "sR": "x234b8571--9199dc--fsk_fill_primary",
  "QZ": "x234b8571--9199dc--fsk_fill_secondary",
  "GR": "x234b8571--9199dc--fsk_fill_white_primary",
  "ZU": "x234b8571--9199dc--fsk_stroke_primary",
};

module.exports = exports;
